const { getCartSectionsToRender } = await import(`./get-sections.js?v=${Date.now()}`);
import "./recommended-products.js";
import "./component-cart-drawer-state.js";
import "./html2canvas.esm.js";
const { renderPrice } = await import(`./configurator-utils.js?v=${Date.now()}`);
const { pricing } = await import(`./pricing.js?v=${Date.now()}`);
const { buttonState } = await import(`./button-state.js?v=${Date.now()}`);
const { bodyLock } = await import(`./body-lock.js?v=${Date.now()}`);
class ConfiguratorOverview extends HTMLElement {
  constructor() {
    super();
    let overviewButton = this.querySelector(".configurator-overview");
    let setDestination = this.querySelector(".set__products");
    let extraDestination = this.querySelector(".extra__products");
    let addToCart = this.querySelector(".js-a2c");
    let a2cButtonText = addToCart.querySelector(".a2c-overview-text");
    document.querySelector(".js-product-variants").innerHTML;
    let extraTitle = this.querySelector(".extra__title");
    let itemCount = this.querySelector("#item-count");
    let baseDiscount = this.dataset.baseDiscount;
    let extraDiscount = this.dataset.extraDiscount;
    let continueToExtra = this.querySelector(".js-continue");
    let continueToSummary = this.querySelector(".js-false");
    let choicePanel = this.querySelector(".configurator-extra-overlay");
    let nextButton = this.querySelector(".js-continue");
    console.log("[debug] continueToExtra:", continueToExtra, "continueToSummary:", continueToSummary, "choicePanel:", choicePanel);
    let buttonRow = document.querySelector(".button-row__fade");
    console.log("overview loaded");
    const nextLayer = () => {
      let nextLayerIndex = nextButton.dataset.next;
      let nextStep = document.querySelector(`.layer-${nextLayerIndex}`);
      document.querySelector(`.layer-label-${nextLayerIndex - 1} .icon-checkmark`);
      let overview = document.querySelector("configurator-overview");
      if (Number(nextLayerIndex) == 5) {
        overview.classList.add("hidden");
      }
      if (Number(nextLayerIndex) >= 5) {
        let buttons = document.querySelectorAll(".button-row__button--hidden");
        buttons.forEach((button) => {
          button.classList.remove("button-row__button--hidden");
        });
      }
      if (nextStep) {
        nextStep.checked = true;
        nextStep.classList.toggle("active");
        nextStep.parentElement.classList.remove("button-row__button--hidden");
        nextStep.parentElement.classList.remove("button-row__button--no-events");
        let currentPosition = buttonRow.scrollLeft;
        buttonRow.scroll({
          top: 0,
          left: currentPosition + nextStep.nextElementSibling.offsetWidth,
          behavior: "smooth"
        });
        if (nextStep.closest(".button-row__button.hidden") != null) {
          document.querySelector(".layer-5").checked = true;
          document.querySelector(".layer-5").classList.add("active");
          document.querySelector(`.layer-label-${5} .icon-checkmark`).classList.toggle("icon-checkmark--active");
        }
      }
    };
    const isBaseConfigComplete = () => {
      let configuratorConfig2 = JSON.parse(sessionStorage.getItem("configuratorConfig"));
      if (configuratorConfig2 == null) return;
      let baseConfig = configuratorConfig2.filter((product) => {
        return product !== null && product.id !== void 0;
      });
      return baseConfig.length >= 3;
    };
    const addDiscount = (discount) => {
      if (discount && baseDiscount && extraDiscount) {
        let _discount = (100 - Number(extraDiscount)) / 100;
        return _discount;
      } else {
        let _discount2 = (100 - Number(baseDiscount)) / 100;
        return _discount2;
      }
    };
    const renderProduct = (product, destination, index = "") => {
      if (product === null) {
        return;
      }
      let layer_index = index || "";
      let isDouble = product.product_type.includes("sloop") || product.option2.includes("80X80") || product.option2.includes("40X80") || product.option2.includes("50X70") || product.option2.includes("60X63") || product.option2.includes("90X200X30") || product.option2.includes("50X80") || product.option2 == "50X160test" && product.product_type == "bedMATE case" || (product.option2.includes("140X200") && product.product_type != "Hoeslaken") || product.option2.includes("140X220") || product.option2.includes("60X70") || product.option2.includes("65X65") || product.option2.includes("50X75") || product.option2.includes("135") || product.option2.includes("155");
      console.log(product);
      console.log("Is double: ", isDouble);
      let basePrice = isDouble ? product.price * 2 : product.price;
      let discountedPrice = basePrice * addDiscount(product == null ? void 0 : product.extraProduct);
      let discountPercentage = Math.round(100 - discountedPrice / basePrice * 100);
      console.log(basePrice, discountedPrice);
      let finalBasePrice = basePrice;
      let finalDiscountedPrice = discountedPrice;
      let productTemplate = `
  <div class="selected-product">
    <div class="image-holder">
      ${product.product_image_url ? `<img src="${product.product_image_url}" alt="${product.title}">` : ""}
    </div>
    <div class="text-holder">
      <p class="text-holder__title">${product.product_title.replace(product.option1, "")}</p>
      <p class="text-holder__option">${product.option1}</p>
      <p class="text-holder__size">${isDouble ? "2X " + product.option2 : product.option2}</p>
      <p class='edit_option' data-layer_index='${layer_index}'>Edit</p>
    </div>
    <div class="selected-product__price">
      <p>
         ${pricing(finalDiscountedPrice)}
        <span>(${discountPercentage}% off)</span><br>
        <s>${pricing(finalBasePrice)}</s>
      </p>
    </div>
  </div>
`;
      destination.insertAdjacentHTML("beforeend", productTemplate);
    };
    const handleProducts = (config) => {
      if (config && config.length > 1) {
        console.log(config, " config");
        setDestination.innerHTML = "";
        extraDestination.innerHTML = "";
        itemCount.innerHTML = config.length - 1;
        config.forEach((product, index) => {
          if (product !== null) {
            product[1] === void 0 && product[2] === void 0 && product[3] === void 0 && product[4] === void 0 && product[5] === void 0 ? renderProduct(product, setDestination, index) : null;
            product["5"] !== void 0 && product["3"] !== null ? renderProduct(product["5"], extraDestination, 5) : null;
            product["4"] !== void 0 && product["3"] !== null ? renderProduct(product["4"], extraDestination, 5) : null;
            product["3"] !== void 0 && product["3"] !== null ? renderProduct(product["3"], extraDestination, 5) : null;
            product["2"] !== void 0 && product["3"] !== null ? renderProduct(product["2"], extraDestination, 5) : null;
            product["1"] !== void 0 && product["3"] !== null ? renderProduct(product["1"], extraDestination, 5) : null;
          }
        });
      }
    };
    let observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes") {
          let _configuratorConfig = JSON.parse(sessionStorage.getItem("configuratorConfig"));
          handleProducts(_configuratorConfig);
          renderPrice(_configuratorConfig);
          if (!isBaseConfigComplete()) {
            addToCart.classList.remove("button--primary");
            addToCart.classList.add("button--ghost");
            a2cButtonText.innerHTML = window.product.complete_your_set;
          } else {
            addToCart.classList.remove("button--ghost");
            addToCart.classList.add("button--primary");
            a2cButtonText.innerHTML = window.variantStrings.add_to_cart;
          }
        }
      });
    });
    if (overviewButton) {
      observer.observe(overviewButton, {
        attributes: true
      });
    }
    let configuratorConfig = JSON.parse(sessionStorage.getItem("configuratorConfig"));
    handleProducts(configuratorConfig);
    addToCart.addEventListener("click", () => {
      if (!isBaseConfigComplete()) {
        addToCart.classList.remove("button--primary");
        addToCart.classList.add("button--ghost");
        a2cButtonText.innerHTML = window.product.complete_your_set;
        return;
      } else {
        addToCart.classList.remove("button--ghost");
        addToCart.classList.add("button--primary");
        a2cButtonText.innerHTML = window.variantStrings.add_to_cart;
      }
      buttonState.loading(addToCart);
      let configuratorConfig2 = JSON.parse(sessionStorage.getItem("configuratorConfig"));
      let setProducts = configuratorConfig2.filter((product) => {
        return product !== null && product.id !== void 0;
      });
      getCartSectionsToRender().map((section) => {
        return section.section;
      });
      this.closest(".shopify-section").id;
      let structuredData = {
        items: [configuratorConfig2[4] && configuratorConfig2[4][1] ? {
          id: configuratorConfig2[4][1].id,
          quantity: 1,
          discount_as: "extra",
          properties: {
            _configuratorItem: "extra"
          }
        } : null, configuratorConfig2[4] && configuratorConfig2[4][2] ? {
          id: configuratorConfig2[4][2].id,
          quantity: 1,
          discount_as: "extra",
          properties: {
            _configuratorItem: "extra"
          }
        } : null, configuratorConfig2[4] && configuratorConfig2[4][3] ? {
          id: configuratorConfig2[4][3].id,
          quantity: 2,
          discount_as: "extra",
          properties: {
            _configuratorItem: "extra"
          }
        } : null, configuratorConfig2[4] && configuratorConfig2[4][4] ? {
          id: configuratorConfig2[4][4].id,
          quantity: 1,
          discount_as: "extra",
          properties: {
            _configuratorItem: "extra"
          }
        } : null, configuratorConfig2[4] && configuratorConfig2[4][5] ? {
          id: configuratorConfig2[4][5].id,
          quantity: 1,
          discount_as: "extra",
          properties: {
            _configuratorItem: "extra"
          }
        } : null],
        sections: getCartSectionsToRender().map((section) => {
          return section.section;
        }),
        sections_url: window.location.pathname,
        attributes: {
          _configuratorItem: "base",
          _configuratorUrl: window.location.pathname + window.location.search,
          _configuratorExtra: configuratorConfig2[4] !== void 0 ? "extra" : null
        }
      };
      setProducts.forEach((selectedVariant) => {
        structuredData.items.push({
          id: selectedVariant.id,
          quantity: selectedVariant.product_title.includes("sloop") || selectedVariant.option2.includes("80X80") || selectedVariant.option2.includes("40X80") || selectedVariant.option2.includes("50X70") || selectedVariant.option2.includes("60X63") || selectedVariant.option2.includes("90X200X30") || selectedVariant.option2.includes("50X80") || selectedVariant.option2 == "50X160test" && selectedVariant.product_type == "bedMATE case" || (selectedVariant.option2.includes("140X200") && selectedVariant.product_type != "Hoeslaken") || selectedVariant.option2.includes("140X220") || selectedVariant.option2.includes("60X70") || selectedVariant.option2.includes("65X65") || selectedVariant.option2.includes("50X75") || selectedVariant.option2.includes("135") || selectedVariant.option2.includes("155") ? 2 : 1,
          discount_as: "base",
          properties: {
            _configuratorItem: "base",
            _minSize: selectedVariant.product_title.includes("sloop") || (selectedVariant.option2.includes("140X200") && selectedVariant.product_type != "Hoeslaken")|| selectedVariant.option2.includes("140X220") || selectedVariant.option2.includes("90") || selectedVariant.option2.includes("60X70") || selectedVariant.option2.includes("65X65") || selectedVariant.option2.includes("50X75") || selectedVariant.option2.includes("50") || selectedVariant.option2.includes("135") || selectedVariant.option2.includes("155") || selectedVariant.option2.includes("50X70") || selectedVariant.option2.includes("60X63") ? 2 : 1
          }
        });
      });
      structuredData.baseItems = structuredData.items.filter((item) => {
        return (item === null || item === void 0 ? void 0 : item.discount_as) === "base";
      });
      structuredData.extraItems = structuredData.items.filter((item) => {
        return (item === null || item === void 0 ? void 0 : item.discount_as) === "extra";
      });
      structuredData.base_discount_amount = Number(addToCart.dataset.baseDiscount) / 100;
      structuredData.extra_discount_amount = Number(addToCart.dataset.extraDiscount) / 100;
      let makeArray = structuredData;
      makeArray.items = makeArray.items.filter((product) => {
        return product != null;
      });
      console.log();
      let selectedItems = JSON.parse(sessionStorage.getItem("configuratorConfig"));
      let filteredItems = selectedItems.filter((selectedItem) => selectedItem !== null);
      let items = [];
      if (selectedItems != null) {
        let addtocart_items = [];
        console.log(filteredItems, selectedItems);
        filteredItems.forEach((val, index) => {
          console.log(Object.entries(val)[0][1]);
          if (Object.entries(val)[0][1].extraProduct == true) {
            for (let i in val) {
              let v = val[i];
              let qty = 1;
              if (v.option2.includes("80X80") || v.option2.includes("40X80") || v.option2.includes("50X70") || v.option2.includes("60X63") || v.option2.includes("90X200X30") || v.option2.includes("50X80") || v.option2 == "50X160test" && v.product_type == "bedMATE case" || v.option2.includes("60X70") || v.option2.includes("65X65") || v.option2.includes("50X75") || v.option2.includes("135") || v.option2.includes("155")) {
                qty = 2;
              }
              if (v && v.product_title && v.option1 && v.option2) {
                items.push({
                  "title": v.product_title,
                  "select_colour": v.full_option1,
                  "select_size": v.full_option2,
                  "price": val.price
                });
                addtocart_items.push({
                  "id": v.id,
                  "quantity": qty,
                  "properties": [
                    {
                      "_configuratorItem": "extra"
                    }
                  ]
                });
              }
            }
          } else {
            let qty = 1;
            if (val.option2.includes("80X80") || val.option2.includes("40X80") || val.option2.includes("50X70") || val.option2.includes("60X63") || val.option2.includes("90X200X30") || val.option2.includes("50X80") || val.option2 == "50X160test" && val.product_type == "bedMATE case" || val.option2.includes("60X70") || val.option2.includes("65X65") || val.option2.includes("50X75") || val.option2.includes("135") || val.option2.includes("155")) {
              qty = 2;
            }
            items.push({
              "title": val.product_title,
              "select_colour": val.full_option1,
              "select_size": val.full_option2,
              "price": val.price
            });
            addtocart_items.push({
              "id": val.id,
              "quantity": qty,
              "properties": [
                {
                  "_configuratorItem": "base"
                }
              ]
            });
          }
        });
        console.log(addtocart_items);
        window.dataLayer.push({
          event: "studiosuite_addToCart",
          ecommerce: {
            currencyCode: "USD",
            add: {
              items
            }
          }
        });
        window.dataLayer = window.dataLayer.filter((item) => {
          var _a;
          if (Array.isArray(item)) {
            return !(item[0] === "event" && item[0] === "add_to_cart" && ((_a = item[2]) == null ? void 0 : _a.send_to));
          }
          return !(item.event && item.send_to);
        });
      }
      makeArray.items.forEach((item) => {
        item.gid = `"gid://shopify/ProductVariant/${item.id}"`;
      });
      let Cart = window.Rebuy.Cart;
      Cart.addItem(structuredData);
      setTimeout(() => {
        buttonState.finishedLoading(addToCart);
      }, 1e3);
      window.updateSummaryPopup();
    });
    if (continueToExtra && continueToSummary) {
      let url = new URL(window.location.href);
      let params = url.searchParams;
      let hasPreloadedConfig = false;
      params.forEach((value, key) => {
        if (key === "bedsheet" || key === "cover" || key === "pillowcase") {
          hasPreloadedConfig = true;
        }
      });
      if (hasPreloadedConfig) {
        let layerThree = document.querySelector(".layer-3-button");
        layerThree.dataset.next = 5;
        choicePanel.classList.add("hidden");
        extraTitle.style.display = "block";
      }
      continueToExtra.addEventListener("click", () => {
        let layerThree = document.querySelector(".layer-3-button");
        layerThree.dataset.next = 5;
        choicePanel.classList.toggle("hidden");
        extraTitle.style.display = "block";
        nextLayer();
      });
      continueToSummary.addEventListener("click", () => {
        choicePanel.classList.toggle("hidden");
        let selectedItems = JSON.parse(sessionStorage.getItem("configuratorConfig"));
        let filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];
        let selected_items = [];
        filteredItems.forEach((val) => {
          if (Object.entries(val)[0][1].extraProduct === true) {
            for (let i in val) {
              let v = val[i];
              if (v && v.product_title && v.option1 && v.option2) {
                selected_items.push({
                  title: v.product_title,
                  select_colour: v.full_option1,
                  select_size: v.full_option2
                });
              }
            }
          } else {
            selected_items.push({
              title: val.product_title,
              select_colour: val.full_option1,
              select_size: val.full_option2
            });
          }
        });
        window.dataLayer = window.dataLayer || [];
        let alreadyPushed = window.dataLayer.some(
          (entry) => {
            var _a;
            return entry.event === "configuratorItemsSelected" && JSON.stringify((_a = entry.ecommerce) == null ? void 0 : _a.items) === JSON.stringify(selected_items);
          }
        );
        if (!alreadyPushed) {
          window.dataLayer.push({
            event: "configuratorItemsSelected",
            ecommerce: {
              items: selected_items
            }
          });
        }
      });
      const showAllButtons = () => {
        let buttons = document.querySelectorAll(".button-row__button");
        buttons.forEach((button) => {
          button.classList.remove("button-row__button--hidden");
        });
      };
      const handleCheckedButtons = () => {
        let url2 = new URL(window.location.href);
        let params2 = url2.searchParams;
        params2.forEach((value, key) => {
          let label = document.querySelector(`label[for="${key}"]`);
          let svg = label === null || label === void 0 ? void 0 : label.querySelector("svg");
          let button = label === null || label === void 0 ? void 0 : label.closest(".button-row__button");
          label === null || label === void 0 ? void 0 : label.classList.add("handled");
          svg === null || svg === void 0 ? void 0 : svg.classList.add("icon-checkmark--active");
          if (label) {
            showAllButtons();
          }
          if (button.classList.contains("hidden") != null) {
            document.querySelector(`.layer-label-${5} .icon-checkmark`).classList.toggle("icon-checkmark--active");
          }
        });
        let backButton = document.querySelector(".show-overview");
        let starter = document.querySelector(".studiosuite-starter");
        let innerContainer = document.querySelector(".main-product__inner--configurator");
        backButton.addEventListener("click", () => {
          starter.classList.remove("studiosuite-starter--hidden");
          this.classList.remove("main-product__inner--configurator-active");
          innerContainer.classList.remove("main-product__inner--configurator-active");
          bodyLock.lock();
        });
      };
      setTimeout(() => {
        handleCheckedButtons();
      }, 200);
    }
  }
}
if (customElements.get("configurator-overview") === void 0) {
  customElements.define("configurator-overview", ConfiguratorOverview);
}
